<template>
  <div>

  </div>
</template>

<script>
export default {
  name:"TwilioSyncStore",
  props:['service'],
  data () { return {
    syncClient: undefined,
    isTwilioFrameworkAvailable: true,
    url: `https://fandango-wombat-7897.twil.io/sync_access_token?k=${this.$_auid}`,
  }},
  async mounted(){
    if(!window.Twilio){
      this.isTwilioFrameworkAvailable = false;
      return;
    }
    this.service ? this.url = `${this.url}&service=${this.service}` : 1+1;
    const r = await axios.get(this.url)
    this.syncClient = new Twilio.Sync.Client(r.data.token);
    
    this.syncClient.on('tokenAboutToExpire', async () => {
      console.log('Updating Token')
      const r = await axios.get(this.url)
      this.syncClient.updateToken(r.data.token);
    }); 
  },
  destroyed(){

  },
  
  
}
</script>

<style scoped>

</style>